import { IAppState } from '../../../types/redux';

export const selectNewbuildingBrokerSelfRequestFormWidgetLoading = (state: IAppState): boolean =>
  state.newbuildingBrokerSelfRequestFormWidget.loading;
